import { Reducer } from 'redux';

import { GroupingModalState, GroupingModalTypes } from './types';

const INITIAL_STATE: GroupingModalState = {
  openModal: false,
  selectedItems: [],
  error: false,
  loading: false,
};

const reducer: Reducer<GroupingModalState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // SET MODAL OPEN
    case GroupingModalTypes.SET_OPEN_MODAL:
      return {
        ...state,
        loading: false,
        error: false,
        openModal: action.payload.openModal,
      };

    // SET SELECTED ITEMS
    case GroupingModalTypes.SET_SELECTED_ITEMS:
      return {
        ...state,
        loading: false,
        error: false,
        selectedItems: action.payload.selectedItems,
      };

    default:
      return state;
  }
};

export default reducer;
